import { ReactNode } from 'react';
import { createPortal } from 'react-dom';

import { isServer } from '../utils';

function Portal({ children }: { children: ReactNode }) {
  if (isServer) return null;

  return createPortal(children, document.body);
}

export default Portal;
